import { FOODHABIT_BASE_URL } from 'Frontend/constants/endpoint'
import { QuizData, QuizSubmission, QuizResult } from '../models/foodHabits.model'

export async function getQuizData(foodHabitStartPageId: string): Promise<QuizData> {
  try {
    const response = await fetch(`${FOODHABIT_BASE_URL}/?contentid=${foodHabitStartPageId}`)
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const jsonResults = await response.json()
    return jsonResults as QuizData
  } catch (error: any) {
    throw new Error(`Failed to fetch quiz data: ${error.message}`)
  }
}

export async function submitQuiz(submission: QuizSubmission): Promise<QuizResult> {
  try {
    const response = await fetch('/api/foodhabit/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(submission),
    })

    if (!response.ok) throw new Error('Failed to fetch results')

    const data = await response.json()
    return data as QuizResult
  } catch (error: any) {
    throw new Error(`Failed to submit quiz: ${error.message}`)
  }
}
